/**
 * Format a phone number in the format +7 (XXX) XXX-XX-XX
 * @param phoneNumber The phone number to format
 * @returns The formatted phone number
 */
export const formatPhoneNumber = (phoneNumber: string | undefined): string => {
  if (!phoneNumber) return '';
  
  // Strip all non-digits
  const digits = phoneNumber.replace(/\D/g, '');
  
  // If the number doesn't start with 7, it's not a valid Kazakhstan number
  if (!digits.startsWith('7') || digits.length < 11) {
    return phoneNumber; // Return as is if it doesn't match the expected format
  }
  
  // Format as +7 (XXX) XXX-XX-XX
  return `+7 (${digits.substring(1, 4)}) ${digits.substring(4, 7)}-${digits.substring(7, 9)}-${digits.substring(9, 11)}`;
}; 